import request from '@/utils/request'

/**
 * 查询异常订单列表（运营态，无 shopId 约束；后端固定查询 state=17 的订单）
 * @param {Object} params 查询参数（page/row）
 * @returns {Promise} Promise对象
 */
export function queryExceptionOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.queryExceptionOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 手动分配回池（订单回到抢单池并清零分配计数）
 * @param {Object} data 请求参数（orderId）
 * @returns {Promise} Promise对象
 */
export function manualAssignDelivery(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.manualAssignDelivery',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询自配送费结算列表
 * @param {Object} params 查询参数（page/row/shopId 可空/deliverySettlementStatus 可空）
 * @returns {Promise} Promise对象
 */
export function queryDeliverySettlement(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.queryDeliverySettlement',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 批量标记配送费已结算
 * @param {Object} data 请求参数（orderIds 数组）
 * @returns {Promise} Promise对象，data 含 successCount/failCount
 */
export function markDeliverySettled(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/admin.order.markDeliverySettled',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
